import WorkData from '../data/works.json';
import { langData } from "../libs/Utils";
import { convertMarkdownToHTML } from "../libs/Sanitizer";
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

export const Works = (props) => {
  const navigate = useNavigate();
  const { lang, ua } = props;
  const nowData = langData(lang, WorkData);
  const [loaded, setLoaded] = useState(false);

  const jumpContent = (data) => {
    if (data.outerLink === undefined) {
      navigate("/works/" + data.id);
    } else {
      window.open(data.outerLink);//, '_blank', 'noreferrer');
    }
  }

  useEffect(() => {
    //setTimeout(() => { props.doneLoaded() }, 5000);
    setLoaded(true);
    //setHeight(document.getElementById("work-blocks").clientWidth);
  }, [])

  const createBlock = (data, key) => {
    let blockStyle = {
      backgroundSize: (data.size ? data.size : "380px"),
      backgroundImage: ('url("/works/' + data.id + '/' + (data.thumbnail === undefined ? "top.jpg" : data.thumbnail) + '")')
    };

    if (ua === "sp") {
      if (document.getElementById("work-blocks") && document.getElementById("items"))
        blockStyle["marginLeft"] = (document.getElementById("items").clientWidth - document.getElementById("work-blocks").clientWidth) / 2 + "px";
      if (document.getElementById("work-blocks"))
        blockStyle["height"] = document.getElementById("work-blocks").clientWidth + "px";
    }


    return (
      <div key={key} className="item work-block" id="items">
        <div
          id="work-blocks"
          className={"work-img"}
          onClick={() => { jumpContent(data) }}
          style={blockStyle}
          alt={data.title} />
        <p className={"work-block-title " + (data.outerLink === undefined ? "" : "gaibus")}
          dangerouslySetInnerHTML={convertMarkdownToHTML(data.title)} />
      </div>
    );
  }

  const calcRow = (data) => {
    return "repeat(" + Math.ceil(data.length / 3) + ", 300px)";
  }

  return (
    <div id="works" className={"page-wrapper " + (loaded ? "opacity-one" : "opacity-zero")}>
      <h1>RESEARCH PROJECTS</h1>
      <div className="work-content">
        <div className="title">Cross-modal Display</div>
        <div className={ua === "sp" ? "work-container-sp" : "work-container"}
          style={{ gridTemplateRows: calcRow(nowData.research[0].contents) }}>
          {nowData.research[0].contents.map((c, i) => createBlock(c, "cmd_" + i))}
        </div >
      </div >
      <div className="work-content">
        <div className="title">Human Augmentation</div>
        <div className={ua === "sp" ? "work-container-sp" : "work-container"}
          style={{ gridTemplateRows: calcRow(nowData.research[1].contents) }}>
          {nowData.research[1].contents.map((c, i) => createBlock(c, "ha_" + i))}
        </div >
      </div>
      <div className="work-content">
        <div className="title">Sensing / Estimation</div>
        <div className={ua === "sp" ? "work-container-sp" : "work-container"}
          style={{ gridTemplateRows: calcRow(nowData.research[2].contents) }}>
          {nowData.research[2].contents.map((c, i) => createBlock(c, "se_" + i))}
        </div>
      </div>
      <h1>EXHIBITION / PRODUCTS</h1>
      <div className="work-content">
        <div className="title"></div>
        <div className={ua === "sp" ? "work-container-sp" : "work-container"}
          style={{ gridTemplateRows: calcRow(nowData.product) }}>
          {nowData.product.map((c, i) => createBlock(c, "p_" + i))}
        </div>
      </div>
      <h1 className={"title" + (nowData.others.length > 0 ? "" : " hidden-div")}>OTHERS</h1>
      <div className="work-content">
        <div className="title"></div>
        <div className={ua === "sp" ? "work-container-sp" : "work-container"}
          style={{ gridTemplateRows: calcRow(nowData.others) }}>
          {nowData.others.map((c, i) => createBlock(c, "p_" + i))}
        </div>
      </div>
    </div >
  );
};